import $ from 'jquery';
import cookies from './_cookies';

let $testPlanForm = $('#gform_3');


function testPlansForm() {
	$testPlanForm.find('input').on('blur', function () {
		let inputVal = $(this).val();
		$(this).val(inputVal).trigger('change');

		console.log($(this).val());
		console.log('changed');
	});
}

export function init() {
	if ($testPlanForm.length) {
		testPlansForm();
	}
}

export default {
	init
};
